export default __webpack_public_path__ + "static/calendar-4612b0357e5f8a63fc76033dabbc7dbb.jpg";